import Service from "./abstract/Service";

export default class TranslationService extends Service {

  findByIso(language = null) {
    return this.get(config.app.url + `/translations/${language}`);
  }
}
